import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  CardActionArea,
  CircularProgress,
  Box,
  Tooltip,
  Stack,
} from "@mui/material";
import axios from "axios";
import ImageCarousel from "components/ImageCarousal";

const LabInventory = () => {
  const { id } = useParams(); // lab ID from URL
  const navigate = useNavigate();

  const [inventory, setInventory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (id) fetchInventory(id);
  }, [id]);

  const fetchInventory = async (labId) => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(
        `https://api.nvcti.in/api/inventory/lab/${labId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const payload = res?.data;
      const normalizedList = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.inventories)
        ? payload.inventories
        : Array.isArray(payload?.data)
        ? payload.data
        : [];
      setInventory(normalizedList);
      setLoading(false);
    } catch (err) {
      console.error("Failed to load inventory:", err);
      setLoading(false);
    }
  };

  const handleItemClick = (item) => {
    navigate("/student/inventory/registration", {
      state: {
        item: item,
        type:"create"

      },
    });
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="80vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  const filteredInventory = (Array.isArray(inventory) ? inventory : [])
    .filter((item) => (item?.name || "").toLowerCase().includes(searchTerm.toLowerCase()));

  return (
    <div className="relative w-full">
      <div className="flex justify-between items-center px-4 mt-6">
        <p className="font-semibold text-lg text-white">Lab Inventory</p>
      </div>

      <div className="px-6 mt-4 mb-6">
        <form className="flex flex-row flex-wrap items-center">
          <div className="relative flex w-full flex-wrap items-stretch">
            <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-900 bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
              <i className="fas fa-search"></i>
            </span>
            <Tooltip title="Search Inventory" arrow>
              <input
                type="text"
                placeholder="Search by Inventory Name"
                className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:ring w-full pl-10 pr-10"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </Tooltip>
            {searchTerm && (
              <button
                type="button"
                onClick={() => setSearchTerm("")}
                className="absolute right-0 top-0 bottom-0 flex items-center justify-center w-10 text-blueGray-900 hover:text-blueGray-600 focus:outline-none"
              >
                <i className="fas fa-times"></i>
              </button>
            )}
          </div>
        </form>
      </div>

      {filteredInventory.length === 0 ? (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="40vh">
          <Typography variant="body1" color="text.secondary">
            No inventory found{searchTerm ? ` for "${searchTerm}"` : ""}.
          </Typography>
        </Box>
      ) : (
        <Grid container spacing={4}>
          {filteredInventory.map((item) => (
            <Grid item xs={12} sm={6} md={4} key={item.id}>
              <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
                <CardActionArea onClick={() => handleItemClick(item)}>
                  <ImageCarousel images={item.inventory_images} />
                  <CardContent>
                    <Typography
                      gutterBottom
                      variant="h6"
                      component="div"
                      sx={{ fontWeight: 600 }}
                    >
                      {item.name}
                    </Typography>
                    {item.description && (
                      <Typography variant="body2" color="text.secondary" mt={1}>
                        {item.description}
                      </Typography>
                    )}
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </div>
  );
};

export default LabInventory;
